




import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconGoogleChevronRight extends Vue {
    @Prop({ type: Number, default: 24 }) readonly size!: number
}
